/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});


	/**
	* Site wide
	*/

	// on mobile, expand submenu if has active menu
	jQuery('.has-submenu-toggle.active').find('ul.submenu').show();

	jQuery(window).scroll(function(){

		// smaller header on scroll
		if(jQuery(document).scrollTop() > 100) {
		 	jQuery('header').addClass('head-not-top');
		} else {
			jQuery('header').removeClass('head-not-top');
		}

		// slide in scroll to top button
		if (jQuery(window).scrollTop() > 200) {
			jQuery('.scroll-top').addClass('in');
		} else {
			jQuery('.scroll-top').removeClass('in');
		}
	});

	// search modal
	var container = jQuery('#searchform');
	var wrapper = jQuery('.search_wrapper');

	jQuery('.btn-navbar-search, .icon-close').click(function(e) {
		e.preventDefault();
		wrapper.fadeToggle();
		jQuery('#s').focus();
	});

	// scroll top
	jQuery('.scroll-top').click(function(e) {
		e.preventDefault();
		jQuery('html, body').animate({
			scrollTop: 0
		}, 850);
	});

	//-------------------------- 
	var _body = jQuery('body');
	//--------------------------
});